import { array, literal, object, string } from "superstruct";

import type { PathParamsBase } from "../endpoint/Endpoint.js";
import Endpoint from "../endpoint/Endpoint.js";
import EndpointRouter from "../endpoint/EndpointRouter.js";
import { ContactSerializedSchema } from "../models/Contact.js";
import { type Projet } from "../models/Projet.js";
import { type User } from "../models/User.js";

export default function buildContactRouter(
    base: EndpointRouter<PathParamsBase, { user: User; projet: Projet }>,
) {
    const router = base.addRouter(new EndpointRouter());

    const endpoints = {
        getContactsEndpoint: router.addEndpoint(
            new Endpoint()
                .setMethod("GET")
                .setPath("/contacts", object({}))
                .setResultParser(array(ContactSerializedSchema)),
        ),
        getContactEndpoint: router.addEndpoint(
            new Endpoint()
                .setMethod("GET")
                .setPath("/contacts/:contact", object({ contact: string() }))
                .setResultParser(ContactSerializedSchema),
        ),
        createContactsEndpoint: router.addEndpoint(
            new Endpoint()
                .setMethod("POST")
                .setPath("/contacts", object({}))
                .setResultParser(string())
                .setBodySchema(ContactSerializedSchema),
        ),
        updateContactEndpoint: router.addEndpoint(
            new Endpoint()
                .setMethod("PUT")
                .setPath("/contacts/:contact", object({ contact: string() }))
                .setResultParser(literal(null))
                .setBodySchema(ContactSerializedSchema),
        ),
        deleteContactEndpoint: router.addEndpoint(
            new Endpoint()
                .setMethod("DELETE")
                .setPath("/contacts/:contact", object({ contact: string() }))
                .setResultParser(literal(null)),
        ),
    };

    return { router, endpoints };
}
